export default __webpack_public_path__ + "static/media/funmilola.ff09333c.png";